var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaestro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0949 12.127C20.0949 15.9394 17.0398 19.03 13.2712 19.03C9.50249 19.03 6.44739 15.9394 6.44739 12.127C6.44739 8.31457 9.50249 5.224 13.2712 5.224C17.0398 5.224 20.0949 8.31457 20.0949 12.127Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9473 12.127C28.9473 15.9394 25.8922 19.03 22.1236 19.03C18.3549 19.03 15.2998 15.9394 15.2998 12.127C15.2998 8.31457 18.3549 5.224 22.1236 5.224C25.8922 5.224 28.9473 8.31457 28.9473 12.127Z",
    fill: "#0099DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6974 6.87305C19.1646 8.13918 20.0949 10.0232 20.0949 12.127C20.0949 14.2308 19.1646 16.1148 17.6974 17.3809C16.2303 16.1148 15.2999 14.2308 15.2999 12.127C15.2999 10.0232 16.2303 8.13918 17.6974 6.87305Z",
    fill: "#6C6BBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/maestro.0f4e76da3d8548e87c2ea6552c325fb5.svg";
export { ForwardRef as ReactComponent };